import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { NavLink as RouterLink } from 'react-router-dom';

const ToolbarActions = () => {
  const { t } = useTranslation('centers');

  return (
    <Box display="flex" justifyContent="flex-end">
      <Button color="primary" variant="contained" component={RouterLink} to="/app/centers/create">
        {t('buttons.create_center')}
      </Button>
    </Box>
  );
};

ToolbarActions.propTypes = {};

export default ToolbarActions;
